export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/header-b6901140583cfc65918a7ac718e11f95.jpg";